export function stickyColumn(element) {
    const stickyElement = document.querySelector('.sticky-content');
    const container = document.querySelector('.sticky-container');
    const stickyOffset = 3 * 10; // Assuming 1rem = 16px, adjust as needed

    let containerTop, containerBottom, stickyHeight;

    // Function to update dimensions and container positions.
    function updateDimensions() {
        // Update container positions relative to the document:
        const containerRect = container.getBoundingClientRect();
        containerTop = containerRect.top + window.pageYOffset;
        containerBottom = containerTop + container.offsetHeight;
        stickyHeight = stickyElement.offsetHeight;
    }

    // Function to update the sticky element's width to match the container.
    function updateStickyWidth() {
        const containerWidth = container.offsetWidth;
        stickyElement.style.width = `${containerWidth}px`;
    }

    // Function to reset sticky styles when below min-width.
    function resetSticky() {
        stickyElement.style.position = '';
        stickyElement.style.top = '';
        stickyElement.style.width = '';
    }

    // Function to handle sticky behavior.
    function handleSticky() {
        // Only apply if window width is at least 980px.
        if (window.innerWidth >= 980) {
            updateDimensions();
            updateStickyWidth();

            const scrollY = window.pageYOffset;

            // If we've scrolled past the container's top minus the offset:
            if (scrollY + stickyOffset >= containerTop) {
                // Calculate where the sticky element's bottom would be if fixed.
                const fixedBottom = scrollY + stickyOffset + stickyHeight;

                if (fixedBottom > containerBottom) {
                    // When it would exceed the container, stick it to the bottom.
                    stickyElement.style.position = 'absolute';
                    stickyElement.style.top = (container.offsetHeight - stickyHeight) + 'px';
                } else {
                    // Normal sticky behavior.
                    stickyElement.style.position = 'fixed';
                    stickyElement.style.top = stickyOffset + 'px';
                }
            } else {
                // Before reaching the container, keep it at the initial position.
                stickyElement.style.position = 'absolute';
                stickyElement.style.top = stickyOffset + 'px';
            }
        } else {
            // When below 980px, reset any inline styles.
            resetSticky();
        }
    }

    // Initial setup.
    updateDimensions();
    updateStickyWidth();
    handleSticky();

    // Listen for scroll events.
    window.addEventListener('scroll', handleSticky);

    // Listen for resize events to re-check the viewport width.
    window.addEventListener('resize', () => {
        updateDimensions();
        updateStickyWidth();
        handleSticky();
    });

}
